import { createControlFn } from "../create-control-fn"

const controlFiscalCodeFieldFn = createControlFn({
  filterValueCb: (value) => /^[a-zA-Z0-9]+$/.test(value),
})

export { controlFiscalCodeFieldFn }
